import React, { useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { observer } from "mobx-react";

import "./CommentModal.scss";
import { useAppStore } from "../../../providers/AppStoreProvider";

export const ReactionModal = observer(() => {
  const store = useAppStore();

  const comment = useMemo(() => {
    let result = store.comments.find((cmt) => cmt.id === store.reactionModal.entityId);

    if (!result) {
      for (const c of store.comments) {
        result = c.childComments?.find((child) => child.id === store.reactionModal.entityId);

        if (result) {
          break;
        }
      }
    }

    return result;
  }, [store.reactionModal.entityId]);

  return (
    <Modal size="md" centered show={store.reactionModal.show} onHide={store.reactionModal.toggle}>
      <Modal.Header closeButton className="border-0">
        <Modal.Title as="h3" className="fw-bold">
          Tất cả
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="list-reactions">
          {comment?.reacts.map(
            (reaction, i) =>
              reaction.status === "active" && (
                <div key={i} className="reaction-block">
                  <div className="reaction-item">
                    <a href="">
                      <div className="reaction-avt-wrap">
                        <div className="reaction-avt">
                          <img
                            className="img-fluid rounded-circle"
                            src={reaction.creator.avatar_url}
                            alt={reaction.creator.name}
                          />
                        </div>
                        <div className="reaction-content d-flex align-items-center justify-content-center">
                          <img
                            className="img-fluid"
                            src={`${process.env.PUBLIC_URL}/assets/icons/${reaction.type}.svg`}
                          />
                        </div>
                      </div>
                    </a>
                    <div className="reaction-name ms-3">{reaction.creator.name}</div>
                  </div>
                </div>
              ),
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
});
